import '@angular/compiler';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { ComponentReviewopsFinancialMetricCardComponent } from './component.reviewops.financial.metric.card/component.reviewops.financial.metric.card.component';
import { ComponentReviewopsIndustryClassificationComponent } from './component.reviewops.industry.classification/component.reviewops.industry.classification.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { ComponentReviewopsCompanySummaryComponent } from './component.reviewops.company.summary/component.reviewops.company.summary.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { ComponentReviewopsFinancialTrendChartComponent } from './component.reviewops.financial.trend.chart/component.reviewops.financial.trend.chart.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { ComponentReviewopsFinancialHealthScoreComponent } from './component.reviewops.financial.health.score/component.reviewops.financial.health.score.component';
import { ComponentReviewopsIndustryTaggingReviewComponent } from './component.reviewops.industry.tagging.review/component.reviewops.industry.tagging.review.component';
import { ComponentReviewopsDataQualityComponent } from './component.reviewops.data.quality/component.reviewops.data.quality.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { ComponentReviewopsRedFlagListComponent } from './component.reviewops.red.flag.list/component.reviewops.red.flag.list.component';
import { ComponentReviewopsInvestmentQuestionsComponent } from './component.reviewops.investment.questions/component.reviewops.investment.questions.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { ComponentReviewopsPeerComparisonComponent } from './component.reviewops.peer.comparison/component.reviewops.peer.comparison.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }